export default __webpack_public_path__ + "static/media/smooth-impact.aa2fb38f.png";